import { Controller } from "@hotwired/stimulus"

// Handles admin decode interactions without touching the audit log.
export default class extends Controller {
  static targets = ["input", "result", "error", "entityType", "state", "stateName", "industry", "yearsInBusiness", "businessPreview"]

  maybeSubmit(event) {
    if (event.type === "keyup" && event.key !== "Enter") {
      return
    }

    this.submit(event)
  }

  async submit(event) {
    if (event) event.preventDefault()

    const token = this.inputTarget.value.trim()
    if (token.length === 0) {
      this.showError("Enter a business EIN to decode.")
      return
    }

    try {
      const response = await fetch("/admin/test-data/business-eins/decode", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({ ein: token })
      })

      if (response.ok) {
        const data = await response.json()
        this.renderResult(data)
      } else {
        const errorPayload = await response.json().catch(() => ({}))
        const message =
          (errorPayload.error && errorPayload.error.message) ||
          errorPayload.error ||
          errorPayload.message ||
          "Unable to decode token."
        this.showError(message)
      }
    } catch (error) {
      this.showError("Unexpected error decoding token. Retry in a moment.")
    }
  }

  renderResult(data) {
    this.errorTarget.hidden = true
    this.errorTarget.textContent = ""

    this.entityTypeTarget.textContent = data.entity_type
    this.stateTarget.textContent = data.state
    this.stateNameTarget.textContent = data.state_name
    this.industryTarget.textContent = data.industry
    this.yearsInBusinessTarget.textContent = `${data.years_in_business} ${data.years_in_business === 1 ? 'year' : 'years'}`

    // Render business preview
    const preview = data.business_preview
    this.businessPreviewTarget.innerHTML = `
      <dl class="space-y-2">
        <div>
          <dt class="font-medium text-slate-600">Business Name</dt>
          <dd class="mt-0.5">${this.escapeHTML(preview.business_name)}</dd>
        </div>
        <div>
          <dt class="font-medium text-slate-600">Address</dt>
          <dd class="mt-0.5">${this.escapeHTML(preview.address)}</dd>
        </div>
        <div>
          <dt class="font-medium text-slate-600">City, State ZIP</dt>
          <dd class="mt-0.5">${this.escapeHTML(preview.city)}, ${preview.state} ${preview.zip}</dd>
        </div>
        <div>
          <dt class="font-medium text-slate-600">Phone</dt>
          <dd class="mt-0.5 font-mono">${this.escapeHTML(preview.phone)}</dd>
        </div>
        <div>
          <dt class="font-medium text-slate-600">Status</dt>
          <dd class="mt-0.5">
            <span class="inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-xs font-semibold text-green-700">
              ${preview.status}
            </span>
          </dd>
        </div>
      </dl>
    `

    this.resultTarget.hidden = false
  }

  showError(message) {
    this.resultTarget.hidden = true
    this.businessPreviewTarget.innerHTML = '<p class="text-slate-500">—</p>'
    this.errorTarget.hidden = false
    this.errorTarget.textContent = message
  }

  escapeHTML(str) {
    const div = document.createElement('div')
    div.textContent = str
    return div.innerHTML
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.getAttribute("content")
  }
}
